import { Component, computed, EventEmitter, inject, input, OnDestroy, output, Output, TemplateRef } from '@angular/core';

import { ButtonActionComponent } from 'src/app/features/shared/controls/container/button-action/button-action.component';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { showAnimation } from 'src/app/infrastructure/animations/show-animation';
import { _CentralPageService } from '../../../services/_central-page.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { loadKey } from 'src/app/infrastructure/services/loading-services/models/loadKey';

@Component({
    selector: 'app-button-block-edit-section',
    templateUrl: './button-block-edit-section.component.html',
    standalone: true,
    imports: [
        SharedModule,
        ButtonActionComponent,
    ],
    styleUrls: ['./button-block-edit-section.component.scss'],
    animations: [
        showAnimation,
    ]
})
export class ButtonsBlockEditSectionComponent
{
    private readonly _centralPageService = injectRequired(_CentralPageService);

    readonly loadKey = loadKey;

    btnCancelData$$ = this._centralPageService.btnCancelData$$;
    btnSaveData$$ = this._centralPageService.btnSaveData$$;

    input_TemplateButtons$$ = input<TemplateRef<any> | null>(null, {alias: 'templateExtraButtons'});
    input_LockOnLoad$$ = input<boolean>(true, {alias: 'lockOnLoad'});

    // Cancel kan verborgen worden (hide) waar een pagina al een eigen terug-knop heeft (bv.
    // PasswordChange); default zichtbaar (SectionButtonCancel.hide = false).
    btnCancelShow$$ = computed(() => !this.btnCancelData$$().hide);
    btnSaveShow$$ = computed(() => !this.btnSaveData$$().hide);

    // Sneltoets-hint toegevoegd aan de bestaande tooltip-tekst — zelfde patroon voor alle
    // vier standaardknoppen (zie ook button-block-details-section.component.ts).
    btnCancelTooltip$$ = computed(() => `${this.btnCancelData$$().tooltip || 'cancel'} [Esc]`);
    btnSaveTooltip$$ = computed(() => `${this.btnSaveData$$().tooltip || 'save'} [Ctrl+S]`);

    emitOnCancel = output({alias: 'onBtnCancel'});
    emitOnSave = output({alias: 'onBtnSave'});

    emit_btnCancel() {
        this.emitOnCancel.emit();
    }

    emit_btnSave() {
        this.emitOnSave.emit();
    }
}
